import { Dimensions } from "react-native";

let W = Dimensions.get("window").width;

Dimensions.addEventListener("change", (e) => {
  const { width } = e.window;
  W = width;
});

function mq(
  max_481: number,
  max_641 = max_481 + (max_481 * 15) / 100,
  min_961 = max_481 + (max_481 * 20) / 100
): number {
  return W < 481 ? max_481 : W < 641 ? max_641 : min_961;
}

export default mq;
